<section class="no-math-container">
  <div class="no-math">
    <div class='actual-quantity'>
      <span class="icon-add-qty">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
      <span class="quantity-value">
        <h5>{{actualQuantity | decimalFormatter}}</h5>
        <h6>{{captions.quantity}} ({{unitCode}})</h6>
      </span>
    </div>
    <app-dynamic-form [config]="config" #form="dynamicForm" (submit)="confirm($event)" (change)="mathonChange($event)">
    </app-dynamic-form>
  </div>
</section>
